/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './AdminReport.css';

class BrandVInfo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: Object.assign({}, props.data)

    }
    this.handleChange = this
      .handleChange
      .bind(this)
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.data != this.props.data) {
      const propsDataAssign = Object.assign({}, nextProps.data)
      this.setState({data: propsDataAssign})
    }
  }

  handleChange = (e) => {
    const {data} = this.state
    const {value, name} = e.target

    data[name] = value

    this.setState({data})
  }

  render() {

    const {data} = this.state

    return (
      <div className={s.root}>
        <div className={s.brandVBox}>
          <form>
            <ul>
              {data.id&&
              <li>
                <label>id</label>
                <input name='id' value={data.id || ''} onChange={this.handleChange}/>
              </li>}
              <li>
                <label>官网名称</label>
                <input name='vName' value={data.vName || ''} onChange={this.handleChange}/>
              </li>
              <li>
                <label>key</label>
                <input name='key' value={data.key || ''} onChange={this.handleChange}/>
              </li>
              <li>
                <label>平台</label>
                <input
                  name='platform'
                  value={data.platform || ''}
                  onChange={this.handleChange}/>
              </li>
            </ul>
            <span className={s.sumbitBtn} onClick={()=>this.props.doChange(this.props.data,data)}>提交</span>
            <span className={s.sumbitBtn} onClick={()=>this.props.close()}>取消</span>

          </form>
        </div>

      </div>
    )

  }
}

export default withStyles(s)(BrandVInfo);



// WEBPACK FOOTER //
// src/routes/adminReport/BrandVInfo.js